var map = {
	"./hibiscus/fullsize/amalfi_edited_3.png": 5233,
	"./hibiscus/fullsize/bilbao_edited_3.png": 3936,
	"./hibiscus/fullsize/cancun_edited_3.png": 2702,
	"./hibiscus/fullsize/cocktail_edited_3.png": 7798,
	"./hibiscus/fullsize/funchal_edited_3.png": 6586,
	"./hibiscus/fullsize/geisha_edited_3.png": 6942,
	"./hibiscus/fullsize/lucca_edited_3.png": 6071,
	"./hibiscus/fullsize/marseille_edited_3.png": 9750,
	"./hibiscus/fullsize/palermo_edited_3.png": 754,
	"./hibiscus/fullsize/portofino_edited_3.png": 4058,
	"./hibiscus/fullsize/premiere_edited_3.png": 4337,
	"./hibiscus/fullsize/roma_edited_3.png": 3951,
	"./hibiscus/fullsize/sabaudia_edited_3.png": 2955,
	"./hibiscus/fullsize/san_remo_edited_3.png": 5218,
	"./hibiscus/fullsize/sorrento_edited_3.png": 559,
	"./hibiscus/fullsize/torino_edited_3.png": 628,
	"./hibiscus/lowres_amalfi_edited_3.png": 6721,
	"./hibiscus/lowres_bilbao_edited_3.png": 4602,
	"./hibiscus/lowres_cancun_edited_3.png": 8548,
	"./hibiscus/lowres_cocktail_edited_3.png": 4515,
	"./hibiscus/lowres_funchal_edited_3.png": 8955,
	"./hibiscus/lowres_geisha_edited_3.png": 352,
	"./hibiscus/lowres_lucca_edited_3.png": 1580,
	"./hibiscus/lowres_marseille_edited_3.png": 42,
	"./hibiscus/lowres_palermo_edited_3.png": 6675,
	"./hibiscus/lowres_portofino_edited_3.png": 1438,
	"./hibiscus/lowres_premiere_edited_3.png": 521,
	"./hibiscus/lowres_roma_edited_3.png": 4497,
	"./hibiscus/lowres_sabaudia_edited_3.png": 6740,
	"./hibiscus/lowres_san_remo_edited_3.png": 5467,
	"./hibiscus/lowres_sorrento_edited_3.png": 452,
	"./hibiscus/lowres_torino_edited_3.png": 735,
	"./mandevilla/fullsize/eagle_eye.png": 2028,
	"./mandevilla/fullsize/pink.png": 4103,
	"./mandevilla/fullsize/red.png": 6120,
	"./mandevilla/fullsize/white.png": 619,
	"./mandevilla/lowres_eagle_eye.png": 396,
	"./mandevilla/lowres_pink.png": 884,
	"./mandevilla/lowres_red.png": 4061,
	"./mandevilla/lowres_white.png": 4297,
	"./partners/logo_agriom.jpeg": 8230,
	"./partners/logo_mba.jpg": 8291,
	"./partners/logo_sunny_cities_new.png": 2035,
	"./piante_keicher_logo.png": 9754,
	"./sfondo/banner.png": 5749,
	"./sfondo/lowres_banner.png": 7901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;